import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { BetHint } from '@ppwr/poker'
import { Checkbox } from '../../../../../Checkbox'
import { DS } from '../../../../../../../design-system'
import { numberWithCommas } from '../../../../../../../utils/numberWithCommas'
interface SuggestedBetRowProps {
  hint: BetHint
  onSelect: (hint: BetHint) => void
  selected: boolean
}

export const SuggestedBetRow = ({ hint, onSelect, selected }: SuggestedBetRowProps) => {
  return (
    <TouchableOpacity style={[styles.container, selected ? styles.selected : {}]} onPress={() => onSelect(hint)}>
      <View style={styles.checkboxContainer}>
        <Checkbox selected={selected} />
        <DS.Text variant="Body Large/Regular" textAlign="center">
          {numberWithCommas(hint.amount)}
        </DS.Text>
      </View>
      <DS.Text variant="Body Small/Regular">{hint.label}</DS.Text>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 40,
    gap: 10,
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderWidth: 2,
    borderColor: 'rgba(221, 218, 210, 1)',
    borderRadius: 4
  },
  selected: {
    borderColor: 'black'
  },
  checkboxContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5
  }
})
